import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {emitTrackEvent, hasSlot} from 'common/util/dom';

import {TrackingEvent} from './tracking';
import template from './index.jade';
import css from './index.styl?inline';

export enum CollapsibleTheme {
  DEFAULT = `default`,
  INLINE = `inline`,
}

const COMPONENT_NAME = `mp-collapsible`;

export class Collapsible extends Component<{isOpen: boolean}> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'enable-row-click': {
        type: `boolean`,
        description: `Enable row click on the entire component`,
      },
      'header-title': `string`,
      'is-closed': `boolean`,
      theme: {
        default: CollapsibleTheme.DEFAULT,
        type: `string`,
        enum: Object.values(CollapsibleTheme),
        description: `The theme of collapsible which determines the styling`,
      },
      'hide-caret': {
        type: `boolean`,
        description: `Hides the caret by default, but show on hover`,
      },
      'tooltip-text': {
        type: `string`,
        description: `ToolTip to be used when hovering over title`,
      },
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      defaultState: {
        isOpen: true,
      },

      helpers: {
        hasSlot,
        CollapsibleTheme,
        toggleOpen: () => {
          const isOpen = !this.state.isOpen;
          const state = isOpen ? `open` : `closed`;

          this.update({isOpen});
          this.track(state);
          this.dispatchEvent(new CustomEvent(`change`, {detail: {state}}));
        },
      },
    };
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);

    if (attr === `is-closed`) {
      this.update({isOpen: !this.attr(`is-closed`)});
    }
  }

  track(state) {
    const event = state === `open` ? TrackingEvent.OpenedCollapsibleSection : TrackingEvent.ClosedCollapsibleSection;
    emitTrackEvent(this, {
      eventName: event,
      eventPrefix: COMPONENT_NAME,
      props: {
        'Collapsible state': state,
        'Section name': this.attr(`header-title`),
      },
      cancelable: true,
    });
  }
}

export const CollapsibleEl = defineAndMakeJsxFactory(COMPONENT_NAME, Collapsible);
